import React from 'react';
import { Layout } from '../components/sections/Layout';
import { FeatureAnalytics } from '../components/sections/FeatureAnalytics';
import { SocialProofSection } from '../components/sections/SocialProofSection';
import { FinalCTA } from '../components/sections/FinalCTA';
export function ApresPage() {
  return <Layout data-id="element-778">
      <FeatureAnalytics data-id="element-779" />
      <SocialProofSection data-id="element-780" />
      <FinalCTA data-id="element-781" />
    </Layout>;
}